export default {
  NEW_CARD: 'new_card',
  EXISTING_CARD: 'existing_card',
  APPLE_PAY: 'apple_pay',
}
